import { Form, Input, Switch, Row, Col, Select } from 'antd';
import { useRef, useState, useEffect } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebProductFileEdit = (props: any) => {
    const { defaultService } = props;
    const [form] = Form.useForm(); //form 
    const ref = useRef<any>(undefined);
    const [productData, setProductData] = useState<any>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (typeof res === 'undefined') { return }
            if (res.success === true) {
                const id = res.data.productId;
                fetchApi.GET(defaultService,
                    {
                        query: {
                            apiId: 'webProduct',
                            apiVariable: id
                        }
                    }).then(res => {
                        if (res.success) {
                            setProductData([res.data]);
                        }
                    });
            }
        })
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId: 'webProductFile',
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={5}>
                        <Form.Item
                            label="ID"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="产品"
                            name="productId"
                            rules={[{ required: false, message: '产品!' }]}>
                            <Select
                                showSearch
                                placeholder="产品"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                disabled={true}>
                                {getList.general(productData, { itemName: 'productName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="文件id"
                            name="fileId">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="文件目录"
                            name="fileDestination">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="文件类型"
                            name="fileType">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="文件大小"
                            name="fileSize">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="图片宽度"
                            name="imageWidth">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="文件高度"
                            name="imageHeight">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="广告图片"
                            name="isAd"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="默认显示"
                            name="isDefault"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default WebProductFileEdit;



